import React, { useState } from 'react';
import { Check, X, ArrowRight, Layers, Clock, BookOpen, TrendingUp, Shield, RefreshCw } from 'lucide-react';
import { motion } from 'framer-motion';
export function EdgeProduct() {
  const [isPartialCampaign, setIsPartialCampaign] = useState(false);
  return <div className="min-h-screen w-full bg-[#0A0F1C] text-slate-200 selection:bg-[#7FE0C3]/30 font-sans" data-id="element-536">
      {/* 1. HERO */}
      <section className="relative pt-32 pb-20 px-6 md:px-12 max-w-7xl mx-auto text-center" data-id="element-537">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-96 bg-slate-500/5 blur-[120px] rounded-full pointer-events-none" data-id="element-538" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-539">
          <div className="inline-block px-3 py-1 rounded-full bg-slate-800 border border-slate-700 text-slate-400 text-xs font-bold uppercase tracking-widest mb-6" data-id="element-540">
            Recruiting Infrastructure
          </div>
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 tracking-tight" data-id="element-541">
            HIRE Edge
          </h1>
          <p className="text-xl md:text-2xl text-slate-400 max-w-3xl mx-auto mb-8 leading-relaxed" data-id="element-542">
            Predictable applicant flow — without changing how you run your team.
          </p>
          <p className="text-lg text-slate-500 max-w-2xl mx-auto border-t border-slate-800 pt-8" data-id="element-543">
            HIRE Edge is designed for teams that want better candidates while
            keeping hiring and onboarding internal.
          </p>
        </motion.div>
      </section>

      {/* 2. WHAT EDGE IS (AND ISN'T) */}
      <section className="py-20 px-6 md:px-12 max-w-5xl mx-auto border-t border-slate-800/50" data-id="element-544">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-545">
          <div data-id="element-546">
            <h3 className="text-lg font-bold text-white mb-6 flex items-center" data-id="element-547">
              <Check className="w-5 h-5 text-[#7FE0C3] mr-2" data-id="element-548" />
              HIRE Edge is:
            </h3>
            <ul className="space-y-4" data-id="element-549">
              {['A recruiting infrastructure layer', 'A predictable source of pre-screened applicants', 'A clean, managed top-of-funnel system'].map((item, idx) => <li key={idx} className="text-slate-300 flex items-start" data-id="element-550">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#7FE0C3] mr-3 mt-2" data-id="element-551" />
                  {item}
                </li>)}
            </ul>
          </div>
          <div data-id="element-552">
            <h3 className="text-lg font-bold text-white mb-6 flex items-center" data-id="element-553">
              <X className="w-5 h-5 text-slate-500 mr-2" data-id="element-554" />
              HIRE Edge is not:
            </h3>
            <ul className="space-y-4" data-id="element-555">
              {['A hiring or onboarding solution', 'A training or retention program', 'A replacement for internal leadership'].map((item, idx) => <li key={idx} className="text-slate-400 flex items-start" data-id="element-556">
                  <span className="w-1.5 h-1.5 rounded-full bg-slate-600 mr-3 mt-2" data-id="element-557" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </section>

      {/* 3. OWNERSHIP MAP */}
      <section className="py-20 px-6 md:px-12 bg-slate-900/20 border-y border-slate-800" data-id="element-558">
        <div className="max-w-6xl mx-auto" data-id="element-559">
          <h2 className="text-3xl font-bold text-white mb-12 text-center" data-id="element-560">
            Ownership Map
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16" data-id="element-561">
            {/* HIRE Owns */}
            <div className="bg-slate-900/40 border border-slate-700 rounded-xl p-8 relative overflow-hidden" data-id="element-562">
              <div className="absolute top-0 left-0 w-full h-1 bg-slate-600" data-id="element-563" />
              <h3 className="text-xl font-bold text-white mb-8 flex items-center" data-id="element-564">
                <span className="w-2 h-2 rounded-full bg-slate-600 mr-3" data-id="element-565" />
                HIRE Owns
              </h3>
              <ul className="space-y-4" data-id="element-566">
                {['Job boards and recruiting traffic', 'Screening and pre-qualification', 'Multi-market coordination', 'Reporting and visibility'].map((item, idx) => <li key={idx} className="flex items-start text-slate-300" data-id="element-567">
                    <Check className="w-5 h-5 text-slate-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-568" />
                    <span data-id="element-569">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* You Own */}
            <div className="bg-slate-900/40 border border-slate-700 rounded-xl p-8 relative overflow-hidden" data-id="element-570">
              <div className="absolute top-0 left-0 w-full h-1 bg-[#7FE0C3]" data-id="element-571" />
              <h3 className="text-xl font-bold text-white mb-8 flex items-center" data-id="element-572">
                <span className="w-2 h-2 rounded-full bg-[#7FE0C3] mr-3" data-id="element-573" />
                You Own
              </h3>
              <ul className="space-y-4" data-id="element-574">
                {['Interviews and hiring decisions', 'Onboarding and training', 'Retention and performance'].map((item, idx) => <li key={idx} className="flex items-start text-slate-300" data-id="element-575">
                    <Check className="w-5 h-5 text-[#7FE0C3] mr-3 mt-0.5 flex-shrink-0" data-id="element-576" />
                    <span data-id="element-577">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="mt-8 text-center" data-id="element-578">
            <p className="text-slate-400" data-id="element-579">
              Edge works best when your internal team already knows how to hire
              and onboard effectively.
            </p>
          </div>
        </div>
      </section>

      {/* 4. HOW EDGE FITS INTO THE SYSTEM */}
      <section className="py-20 px-6 md:px-12 max-w-4xl mx-auto" data-id="element-580">
        <div className="bg-slate-900/30 border border-slate-800 rounded-xl p-8 md:p-12 text-center" data-id="element-581">
          <h2 className="text-2xl font-bold text-white mb-6" data-id="element-582">
            How Edge Fits Into The System
          </h2>
          <p className="text-slate-300 mb-6 leading-relaxed" data-id="element-583">
            All HIRE partners use the same 10-step recruiting system. Edge
            focuses on the infrastructure stages so your team can handle
            execution.
          </p>
          <div className="flex flex-wrap justify-center gap-3 text-sm" data-id="element-584">
            {['Attract', 'Engage', 'Screen', 'Qualify'].map((step, idx) => <span key={idx} className="px-4 py-2 bg-slate-800 border border-slate-700 rounded-full text-slate-400" data-id="element-585">
                {step}
              </span>)}
            <span className="px-4 py-2 text-slate-600" data-id="element-586">→</span>
            {['Interview', 'Commit', 'Onboard', 'Integrate', 'Train', 'Launch', 'Retain'].map((step, idx) => <span key={idx} className="px-4 py-2 bg-slate-900 border border-slate-800 rounded-full text-slate-500" data-id="element-587">
                {step}
              </span>)}
          </div>
          <p className="text-xs text-slate-500 mt-6" data-id="element-588">
            Infrastructure stages (highlighted) vs. execution stages
          </p>
        </div>
      </section>

      {/* 5. PRICING */}
      <section className="py-20 px-6 md:px-12 bg-slate-900/20 border-y border-slate-800" data-id="element-589">
        <div className="max-w-6xl mx-auto" data-id="element-590">
          <div className="text-center mb-12" data-id="element-591">
            <h2 className="text-3xl font-bold text-white mb-4" data-id="element-592">
              Partnership Pricing
            </h2>
            <p className="text-slate-400" data-id="element-593">
              Predictable applicant flow — without changing how you run your
              team.
            </p>
          </div>

          <div className="flex justify-center mb-12" data-id="element-594">
            <div className="bg-slate-900/50 p-1 rounded-lg border border-slate-800 flex items-center" data-id="element-595">
              <button onClick={() => setIsPartialCampaign(false)} className={`px-4 py-2 rounded-md text-sm font-medium transition-all ${!isPartialCampaign ? 'bg-slate-600 text-white shadow-lg' : 'text-slate-400 hover:text-white'}`} data-id="element-596">
                Full Campaign
              </button>
              <button onClick={() => setIsPartialCampaign(true)} className={`px-4 py-2 rounded-md text-sm font-medium transition-all ${isPartialCampaign ? 'bg-slate-600 text-white shadow-lg' : 'text-slate-400 hover:text-white'}`} data-id="element-597">
                Partial Campaign
              </button>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-598">
            {/* Build Fee */}
            <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl relative overflow-hidden" data-id="element-599">
              <div className="mb-4" data-id="element-600">
                <div className="text-xs text-slate-500 uppercase tracking-widest mb-2" data-id="element-601">
                  Build (One-Time)
                </div>
                <div className="text-3xl font-bold text-white" data-id="element-602">$3,000</div>
                <div className="mt-4 inline-flex items-center px-3 py-1 rounded-full bg-[#7FE0C3]/10 border border-[#7FE0C3]/20 text-[#7FE0C3] text-xs font-bold" data-id="element-603">
                  <Shield className="w-3 h-3 mr-1.5" data-id="element-604" />
                  Money Back Guarantee
                </div>
              </div>
            </div>

            {/* Monthly Total */}
            <div className="bg-slate-900/40 border border-slate-600 p-6 rounded-xl relative" data-id="element-605">
              <div className="absolute top-0 left-0 w-full h-1 bg-slate-500 rounded-t-xl" data-id="element-606" />
              <div className="mb-4" data-id="element-607">
                <div className="text-xs text-slate-400 uppercase tracking-widest mb-2" data-id="element-608">
                  Total Monthly
                </div>
                <div className="text-4xl font-bold text-white mb-1" data-id="element-609">
                  ${isPartialCampaign ? '2,250' : '3,000'}
                </div>
                <div className="text-sm text-slate-500 mb-6" data-id="element-610">/ month</div>

                <div className="space-y-3 pt-4 border-t border-slate-800/50" data-id="element-611">
                  <div className="flex justify-between text-sm" data-id="element-612">
                    <span className="text-slate-400" data-id="element-613">System Fee</span>
                    <span className="text-white font-medium" data-id="element-614">$1,500</span>
                  </div>
                  <div className="flex justify-between text-sm" data-id="element-615">
                    <span className="text-slate-400" data-id="element-616">
                      {isPartialCampaign ? 'Partial' : 'Full'} Campaign
                    </span>
                    <span className="text-white font-medium" data-id="element-617">
                      ${isPartialCampaign ? '750' : '1,500'}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Performance Bonuses */}
            <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl" data-id="element-618">
              <div className="mb-4" data-id="element-619">
                <div className="text-xs text-slate-500 uppercase tracking-widest mb-2" data-id="element-620">
                  Performance Bonuses
                </div>
                <div className="text-2xl font-bold text-slate-600" data-id="element-621">None</div>
              </div>
            </div>
          </div>

          <div className="mt-8 p-6 bg-slate-900/40 border border-slate-800 rounded-lg max-w-3xl mx-auto" data-id="element-622">
            <p className="text-slate-400 text-center" data-id="element-623">
              HIRE Edge does not include placement or retention bonuses because
              hiring and retention remain internal.
            </p>
          </div>
        </div>
      </section>

      {/* 6. LMS + SUPPORT */}
      <section className="py-20 px-6 md:px-12 max-w-4xl mx-auto" data-id="element-624">
        <div className="flex items-start space-x-6 bg-slate-900/30 border border-slate-800 rounded-xl p-8" data-id="element-625">
          <div className="w-12 h-12 rounded-lg bg-slate-800 flex items-center justify-center flex-shrink-0" data-id="element-626">
            <BookOpen className="w-6 h-6 text-slate-400" data-id="element-627" />
          </div>
          <div data-id="element-628">
            <h3 className="text-xl font-bold text-white mb-4" data-id="element-629">
              Learning Management System Access
            </h3>
            <p className="text-slate-300 mb-4 leading-relaxed" data-id="element-630">
              All Edge partners receive access to HIRE's Learning Management
              System covering recruiting and hiring best practices.
            </p>
            <ul className="space-y-2 text-slate-400 text-sm" data-id="element-631">
              <li className="flex items-start" data-id="element-632">
                <span className="w-1.5 h-1.5 rounded-full bg-slate-600 mr-2 mt-1.5" data-id="element-633" />
                DIY reference library
              </li>
              <li className="flex items-start" data-id="element-634">
                <span className="w-1.5 h-1.5 rounded-full bg-slate-600 mr-2 mt-1.5" data-id="element-635" />
                Optional support and guidance
              </li>
              <li className="flex items-start" data-id="element-636">
                <span className="w-1.5 h-1.5 rounded-full bg-slate-600 mr-2 mt-1.5" data-id="element-637" />
                Not a replacement for internal execution
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* 7. WHO EDGE IS FOR */}
      <section className="py-20 px-6 md:px-12 bg-slate-900/20 border-y border-slate-800" data-id="element-638">
        <div className="max-w-5xl mx-auto" data-id="element-639">
          <h2 className="text-3xl font-bold text-white mb-12 text-center" data-id="element-640">
            Who Edge Is For
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-641">
            <div data-id="element-642">
              <h3 className="text-lg font-bold text-white mb-6 flex items-center" data-id="element-643">
                <Check className="w-5 h-5 text-[#7FE0C3] mr-2" data-id="element-644" />
                Edge is a good fit if you:
              </h3>
              <ul className="space-y-4" data-id="element-645">
                {['Already have strong onboarding and training', 'Want better candidate quality and predictability', 'Prefer to keep hiring decisions internal', 'Want a lower-commitment entry point'].map((item, idx) => <li key={idx} className="text-slate-400 flex items-start" data-id="element-646">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#7FE0C3] mr-3 mt-2" data-id="element-647" />
                    {item}
                  </li>)}
              </ul>
            </div>
            <div data-id="element-648">
              <h3 className="text-lg font-bold text-white mb-6 flex items-center" data-id="element-649">
                <X className="w-5 h-5 text-slate-500 mr-2" data-id="element-650" />
                Edge is not a good fit if you:
              </h3>
              <ul className="space-y-4" data-id="element-651">
                {['Want help fixing retention', 'Want hiring standards designed for you', 'Want recruiting execution handled externally'].map((item, idx) => <li key={idx} className="text-slate-400 flex items-start" data-id="element-652">
                    <span className="w-1.5 h-1.5 rounded-full bg-slate-600 mr-3 mt-2" data-id="element-653" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 8. UPGRADE PATH */}
      <section className="py-20 px-6 md:px-12 max-w-4xl mx-auto" data-id="element-654">
        <div className="flex items-start space-x-6 bg-slate-900/30 border border-slate-800 rounded-xl p-8" data-id="element-655">
          <div className="w-12 h-12 rounded-lg bg-slate-800 flex items-center justify-center flex-shrink-0" data-id="element-656">
            <TrendingUp className="w-6 h-6 text-slate-400" data-id="element-657" />
          </div>
          <div data-id="element-658">
            <h3 className="text-xl font-bold text-white mb-4" data-id="element-659">
              Natural Progression
            </h3>
            <p className="text-slate-300 leading-relaxed" data-id="element-660">
              Many Edge partners later move into Advantage when they want system
              ownership and accountability — without changing platforms or
              starting over.
            </p>
          </div>
        </div>
      </section>

      {/* 9. CTA */}
      <section className="py-32 px-6 md:px-12 text-center border-t border-slate-800/50" data-id="element-661">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-662">
          See if HIRE Edge fits your hiring model.
        </h2>
        <button className="inline-flex items-center px-8 py-4 bg-slate-700 hover:bg-slate-600 text-white font-bold rounded-lg transition-all" data-id="element-663">
          Learn More
          <ArrowRight className="ml-2 w-5 h-5" data-id="element-664" />
        </button>
      </section>
    </div>;
}